import React, { useState } from "react";
import "./Navbar.css";


const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="navbar">
      <div className="logo">🌸NEW KALPANA NURSERY🌸</div>

      {/* 🍔 Hamburger */}
      <div 
        className="menu-toggle"
        onClick={() => setMenuOpen(!menuOpen)}
      >
        ☰
      </div>

      {/* Menu */}
      <ul className={menuOpen ? "active" : ""}>
  <li onClick={() => setMenuOpen(false)}><a href="#home">Home</a></li>
  <li onClick={() => setMenuOpen(false)}><a href="#flowers">Flowers</a></li>
  <li onClick={() => setMenuOpen(false)}><a href="#gallery">Gallery</a></li>
  <li onClick={() => setMenuOpen(false)}><a href="#contact">Contact</a></li>
  <li onClick={() => setMenuOpen(false)}><a href="/admin">Admin</a></li>
</ul>
    </div>
  );
};

export default Navbar;